import { useState } from "react";
import { useStateValue } from "../../context/StateProvider";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";


const Body = ({ action, setOrdered }: { action: any, setOrdered: any }) => {
  const [{ location, cartItems, deliveryFees, cartTotal/*, formattedLocation*/, products }, dispatch] = useStateValue();
  const [additionalDetails, setAdditionalDetails] = useState(localStorage.getItem('locationDetails') || "");
  const [name, setName] = useState(localStorage.getItem('username') || "");
  const [phone, setPhone] = useState(localStorage.getItem('phoneNumber') || "");
  const [email, setEmail] = useState(localStorage.getItem('email') || "");
  const [loading, setLoading] = useState(false);
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    locationDetails: ""
  });

  const validateFields = () => {
    const newErrors: any = {};

    if (!name.trim()) newErrors.name = "Full name is required.";
    if (!phone.trim()) newErrors.phone = "Phone number is required.";
    if (!email.trim()) newErrors.email = "Email is required.";
    if (!additionalDetails.trim()) newErrors.locationDetails = "Location details are required.";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const grandTotal = Number(cartTotal) + Number(deliveryFees) || 'Nill';


  const generateOrderId = () => {
    const timestamp = Date.now().toString().slice(-4); // Last 4 digits of the timestamp
    const randomNum = Math.floor(1000 + Math.random() * 9000); // 4-digit random number
    return `${timestamp}${randomNum}`;
  };

  const currentDate = new Date();
  function formatDate(date: any) {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
  }

  const formattedDate = formatDate(currentDate);


  const handlePlaceOrder = async () => {

    setLoading(true)
    try {

    if (!validateFields()) {
      setLoading(false);
      return;
    }
      // !selectedLocation || 
      if (!name || !phone || !additionalDetails) {
        alert("Please fill all the details.");
        return;
      }

      localStorage.setItem('username', name);
      localStorage.setItem('phoneNumber', phone);
      localStorage.setItem('email', email);
      localStorage.setItem('locationDetails', additionalDetails);

      const orderId = uuidv4();

      const items: any[] = cartItems.map((item: { fid: any; qty: any; }) => {

        const toSetProduct = products?.find((pro: { id: any; }) => pro.id === item?.fid)

        const { imageURL, title, description, ...rest } = toSetProduct;

        const send = {
          id: item?.fid,
          quantity: item?.qty,
          price: rest.price,
          product: {
            ...rest,
            productImage: imageURL,
            productName: title,
            productDesc: description
          }
        }

        return send
      })

      const order = {
        orderId: orderId,
        //     orderIdshort: tempoid, 
        email: email || null,
        orderIdshortUnique: generateOrderId(),
        username: name,
        phoneNumber: phone,
        status: 1,
        quantityOfItems: cartItems?.length,
        formattedLocation: 'Nill',
        deliveryFees: deliveryFees,
        latitude: location.lat.toFixed(6) || null,
        longitude: location.lat.toFixed(6) || null,
        date: formattedDate,
        items: items,
        totalPrice: grandTotal,
        accepted: false,
        locationDetails: additionalDetails || null,
        cancelledByUser: false,
        riderAcceptCancel: 'none_false_false',
        fromWebsite: true,
        createdAt: Date.now(),
      };


      await axios.post(`${process.env.REACT_APP_BASE_URL}/order/create`, { order })

      setOrderPlaced(true);
      setOrdered(true);

      dispatch({
        type: "SET_CARTITEMS",
        cartItems: []
      });

      dispatch({
        type: "SET_CART_TOTAL",
        cartTotal: 0
      });


    } catch (error: any) {
      console.log('Error = ', error.response.data.error)
    } finally {
      setLoading(false);
    }

  };

  const handleClose = () => {

    dispatch({
      type: "TOGGLE_CART",
      showCart: false,
    });
  }

  return (
    <div className="w-full h-full">

      {!orderPlaced ? (

        <div className="w-full h-full flex flex-col rounded-t-[2rem] bg-cartBg overflow-hidden">
          {/* Scrollable content */}
          <div className="h-[85%] overflow-y-auto px-6 py-4">
            {/* Form Fields */}
            <div className="mb-4 h-[17%]">
              <label className="block text-slate-300">Your Name:</label>
              <input
                type="text"
                className="w-full p-3 rounded-lg border"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (errors.name) setErrors({ ...errors, name: "" });
                }}
                placeholder="Enter your full name"
              />
              {errors.name && <p className="text-red-500 text-sm mb-2">{errors.name}</p>}
            </div>


            <div className="mb-4 h-[17%]">
              <label className="block text-slate-300">Phone Number:</label>
              <input
                type="tel"
                inputMode="tel"
                pattern="[\d+\-() ]*"
                className="w-full p-3 rounded-lg border"
                value={phone}
                onChange={(e) => {
                  const input = e.target.value;
                  const cleaned = input.replace(/[^0-9+\-() ]/g, ''); // blocks letters and symbols
                  setPhone(cleaned);
                  if (errors.phone) setErrors({ ...errors, phone: "" });
                }}

                placeholder="Enter your phone number"
              />
              {errors.phone && <p className="text-red-500 text-sm mb-2">{errors.phone}</p>}
            </div>
            <div className="mb-4 h-[17%]">
              <label className="block text-slate-300">Email:</label>
              <input
                type="email"
                className="w-full p-3 rounded-lg border"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (errors.email) setErrors({ ...errors, email: "" });
                }}
                placeholder="Enter your email address"
              />
              {errors.email && <p className="text-red-500 text-sm mb-2">{errors.email}</p>}
            </div>

            <div className="mb-4 h-[25%]">
              <label className="block text-slate-300">Location Details:</label>
              <textarea
                // type="text"
                className="w-full p-3 rounded-lg border h-[70%]"
                value={additionalDetails}
                onChange={(e) => {
                  setAdditionalDetails(e.target.value);
                  if (errors.locationDetails) setErrors({ ...errors, locationDetails: "" });
                }}
                placeholder="House/Flat, Street, Nearby landmark..."
              />
              {errors.locationDetails && <p className="text-red-500 text-sm mb-2">{errors.locationDetails}</p>}
            </div>

          </div>

          {/* Fixed button at bottom */}
          <div className="h-[15%] p-4">
            <button
              className="w-full px-6 py-3 bg-redPrimary text-white font-semibold rounded-lg shadow-lg hover:bg-red-700 transition duration-300 flex items-center justify-center gap-2"
              onClick={handlePlaceOrder}
              disabled={loading}
            >
              {loading && (
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
              )}
              {loading ? "Placing..." : "Place Order"}
            </button>
          </div>

        </div>) : (

        <div className="w-full h-full flex flex-col justify-center items-center p-6 rounded-t-[2rem] text-center space-y-6">
          <div className="text-green-600 text-4xl">✅</div>
          <h2 className="text-2xl font-bold text-gray-800">Order Placed Successfully!</h2>
          <p className="text-gray-600 text-base">
            Thank you for your order. Our rider will contact you soon to confirm the location and delivery details.
          </p>
          <p className="text-gray-700 text-base">
            If needed, you can reach us directly at:
            <br />
            <span className="text-red-500 font-semibold text-lg">+92-3218628554</span>
          </p>
          <button
            onClick={handleClose} // Replace with your handler
            className="mt-4 px-6 py-3 bg-redPrimary text-white font-semibold rounded-lg shadow hover:bg-red-700 transition"
          >
            OK
          </button>
        </div>

      )}
    </div>
  );
};

export default Body;
